import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    source_device: null,
    is_submit_btn_disable: false
  },
  mutations: {
    INIT_TRANSFER_DEVICE_DATA_DIALOG(state, payload) {
      state.visibility = true
      state.source_device = payload
    },
    RESET_TRANSFER_DEVICE_DATA_DIALOG(state) {
      state.visibility = false
      state.source_device = null
    },
    SET_TRANSFER_DEVICE_DATA_DIALOG_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.is_submit_btn_disable = payload
    }
  },
  actions: {
    async transferDeviceData({ commit }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.transferring'), loading: true })
        commit('SET_TRANSFER_DEVICE_DATA_DIALOG_IS_SUBMIT_BTN_DISABLE', true)

        const response = await api.transferDeviceData({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          commit('RESET_TRANSFER_DEVICE_DATA_DIALOG')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_TRANSFER_DEVICE_DATA_DIALOG_IS_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
